import type { CountryCode } from "libphonenumber-js";

import { useState } from "react";

import { NewCallCallControl } from "./NewCallCallControl";
import { NoActiveCallControl } from "./NoActiveCallControl";

interface IdleNoCallControlsProps {
    isInternationalPhoneEnabled: boolean;
    defaultCountry: CountryCode;
}

export function IdleNoCallControls({ isInternationalPhoneEnabled, defaultCountry }: IdleNoCallControlsProps) {
    const [isAddingCall, setIsAddingCall] = useState(false);

    function handleAddCallClick() {
        setIsAddingCall(true);
    }

    function handleCancelAddCallClick() {
        setIsAddingCall(false);
    }

    if (isAddingCall) {
        return (
            <NewCallCallControl
                onAddCall={handleAddCallClick}
                onCancel={handleCancelAddCallClick}
                isInternationalPhoneEnabled={isInternationalPhoneEnabled}
                defaultCountry={defaultCountry}
            />
        );
    }

    return <NoActiveCallControl onAddCall={handleAddCallClick} />;
}
